import React from "react";
import { Delete } from "@dreamhub/designsystem/icons";
import { IconButton, IconButtonProps } from "@/components/ui/icon-button";
import { cn } from "@/utils/utils";

const DeleteIconButton: React.FC<IconButtonProps> = ({
  onClick,
  className,
  ...props
}) => (
  <IconButton
    className={cn("-translate-y-1", className)}
    variant="iconNoBg"
    size="md"
    iconColor="secondary"
    onClick={onClick}
    {...props}
  >
    <Delete />
  </IconButton>
);

export default DeleteIconButton;
